var _path, _rect;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIn(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.95168 9.80685H8.97313V19.5254H5.95168V9.80685ZM7.46368 8.47813C8.42841 8.47813 9.21495 7.69413 9.21495 6.72686C9.21495 6.49688 9.16965 6.26915 9.08164 6.05667C8.99363 5.8442 8.86464 5.65114 8.70202 5.48852C8.5394 5.3259 8.34634 5.1969 8.13386 5.10889C7.92139 5.02088 7.69366 4.97559 7.46368 4.97559C7.2337 4.97559 7.00597 5.02088 6.7935 5.10889C6.58102 5.1969 6.38796 5.3259 6.22534 5.48852C6.06272 5.65114 5.93373 5.8442 5.84572 6.05667C5.75771 6.26915 5.71241 6.49688 5.71241 6.72686C5.70986 7.69413 6.49386 8.47813 7.46368 8.47813ZM13.8859 14.717C13.8859 13.4494 14.1277 12.2225 15.6982 12.2225C17.2459 12.2225 17.2688 13.6709 17.2688 14.7985V19.5254H20.2877V14.1952C20.2877 11.5785 19.7226 9.56504 16.6655 9.56504C15.1968 9.56504 14.2117 10.3719 13.8069 11.1356H13.7662V9.80685H10.8669V19.5254H13.8859V14.717Z",
    fill: "#9F9F9F"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 24,
    height: 24,
    rx: 6,
    stroke: "#9F9F9F",
    strokeWidth: 2
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIn);
export default __webpack_public_path__ + "static/media/in.600b87b4324ba953f1b85752463e365f.svg";
export { ForwardRef as ReactComponent };